import React, { Component } from 'react'
import SpinnerPageUI from './SpinnerPageUI.js'

class SpinnerPageSF extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <SpinnerPageUI
        context={this.props.context}
      />
    );
  }

  UNSAFE_componentWillMount() {
  }

  componentDidMount() {
    document.body.classList.add('sdp')
  }

}

export default SpinnerPageSF
